var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-legend"},[_vm._v("\n  "+_vm._s(_vm.minText)+"\n  "),_c('span',{staticClass:"color-bar",style:(_vm.styleObj)}),_vm._v("\n  "+_vm._s(_vm.maxText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }